import { router } from '@inertiajs/vue3';

export function useServidorNavigation() {
    const getAreaServidorRoute = () => route('servicos', { agrupamento: 'personas', path: '6' });
    const getServidorRoute = (matriculaId) => route('servidor.show', { matriculaId });
    const getAssentamentosRoute = (matriculaId) => route('servidor.page.assentamentos', { matriculaId });
    const getAverbacoesRoute = (matriculaId) => route('servidor.page.averbacoes', { matriculaId });
    const getFeriasRoute = (matriculaId) => route('servidor.page.ferias', { matriculaId });
    const getComprovanteRendimentosRoute = (matriculaId) => route('servidor.comprovante-rendimentos', { matriculaId });
    const getContrachequesRoute = (matriculaId) => route('servidor.contracheques', { matriculaId });

    const goToAreaServidor = () => router.visit(getAreaServidorRoute());
    const showServidor = (matriculaId) => router.visit(getServidorRoute(matriculaId));
    const showAssentamentos = (matriculaId) => router.visit(getAssentamentosRoute(matriculaId));
    const showAverbacoes = (matriculaId) => router.visit(getAverbacoesRoute(matriculaId));
    const showFerias = (matriculaId) => router.visit(getFeriasRoute(matriculaId));
    const showComprovanteRendimentos = (matriculaId) => router.visit(getComprovanteRendimentosRoute(matriculaId));
    const showContracheques = (matriculaId) => router.visit(getContrachequesRoute(matriculaId));

    return {
        getAreaServidorRoute,
        getServidorRoute,
        getAssentamentosRoute,
        getAverbacoesRoute,
        getFeriasRoute,
        getComprovanteRendimentosRoute,
        getContrachequesRoute,
        goToAreaServidor,
        showServidor,
        showAssentamentos,
        showAverbacoes,
        showFerias,
        showComprovanteRendimentos,
        showContracheques
    };
}
